import { render, staticRenderFns } from "./LoadImage.vue?vue&type=template&id=1bb7d8be"
import script from "./LoadImage.vue?vue&type=script&lang=ts"
export * from "./LoadImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports